import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

const ParamField = ({ title, value, setValue, units, disabled }) => {
    const [isFocus, setFocus] = useState(false);
    const [innerValue, setInnerValue] = useState(value);

    useEffect(() => setInnerValue(value), [value]);

    const onBlur = () => {
        setValue(innerValue == "" ? 0 : innerValue);
        if (innerValue == "") setInnerValue(0)
    }

    return (
        <div className="paramField" onBlur={onBlur}>
            <div className="text">{title}</div>
            <div className={`input_num_minute${innerValue==0?" null":""}${isFocus?" focus":""}`}><input 
                type="number" 
                value={innerValue}
                onChange={(event) => setInnerValue(event.target.value)}
                onFocus={() => {
                    setFocus(true);
                    if (value == 0) setValue("");
                }}
                onBlur={() => {
                    setFocus(false)
                    if (value == 0) setValue("");
                }}
                disabled={disabled}
            /><span>{units ? units : "мин."}</span></div>
        </div>
    )
}

export default observer(ParamField);
